import PropTypes from "prop-types";
import styles from "./index.css";
import SinglePageAppLink from "../../../../../../../SinglePageAppLink";
import LazyProductImage from "../../../../../../../ProductTile/LazyProductImage";

const ImagePill = ({ friendlyName, linkUrl, imageUrl }) => (
  <li>
    <SinglePageAppLink href={linkUrl} className={styles.wrapper}>
      <LazyProductImage src={imageUrl} />
      <p className={styles.title}>{friendlyName}</p>
    </SinglePageAppLink>
  </li>
);

ImagePill.propTypes = {
  friendlyName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  extraClassName: PropTypes.string
};

export default ImagePill;
